import { Raycaster, Vector2, type Camera } from 'three';
import type { BoardMeshes } from './cells.js';
import type { Coord } from '../core/types.js';

const ray = new Raycaster();
const ndc = new Vector2();

export const pickCell = (
  ev: { clientX: number; clientY: number },
  canvas: HTMLCanvasElement,
  camera: Camera,
  meshes: BoardMeshes,
): Coord | null => {
  const rect = canvas.getBoundingClientRect();
  ndc.x = ((ev.clientX - rect.left) / rect.width) * 2 - 1;
  ndc.y = -(((ev.clientY - rect.top) / rect.height) * 2 - 1);
  ray.setFromCamera(ndc, camera);
  const flat = meshes.cells.flat();
  const hits = ray.intersectObjects(flat, false);
  const first = hits[0];
  if (!first) return null;
  const data = first.object.userData as { x?: number; y?: number };
  if (typeof data.x !== 'number' || typeof data.y !== 'number') return null;
  return { x: data.x, y: data.y };
};
